const roles = Object.freeze({
  MANAGER: 'manager',
  OWNER: 'owner',
  SUPERVISOR: 'supervisor',
})

export default roles
